import { Box } from "@mui/material";
import type { Field, SectionFieldsProps } from "../../types";
import { FieldDisplay } from "./Fields";

function fieldsInOrder(fields: Array<Field>): Array<Field> {
  return [...fields].sort(
    (firstField, secondField) => firstField.index - secondField.index,
  );
}

function SectionFields({
  fields,
  columns,
  fieldIdPrefix,
  highlightMissingFields = true,
}: SectionFieldsProps) {
  const columnCount = Math.max(columns, 1);

  return (
    <Box
      data-testid="section-fields"
      data-columns={columnCount}
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "minmax(0, 1fr)",
          md: `repeat(${columnCount}, minmax(0, 1fr))`,
        },
        gap: 2,
        minWidth: 0,
      }}
    >
      {fieldsInOrder(fields).map((field) => (
        <Box
          key={`${field.index}-${field.name ?? "field"}`}
          data-testid={`field-${field.index}`}
          data-full-line={field.fullLine === true ? "true" : "false"}
          sx={{
            gridColumn: field.fullLine ? "1 / -1" : "auto",
            minWidth: 0,
          }}
        >
          <FieldDisplay
            field={field}
            resolvedFieldId={`${fieldIdPrefix}-field-${field.index}-value`}
            highlightMissingFields={highlightMissingFields}
          />
        </Box>
      ))}
    </Box>
  );
}

export default SectionFields;
